
// Adds 'section-anim-in' / 'section-in-view' classes to <main> .shopify-section
// elements as they enter the viewport, so CSS in assets/animations.css can
// transition them from opacity:0/translateY(80px) to their resting state.
//
// Design goals:
//   - No reveal failure on the storefront. Stock Taiga used
//     `Shopify || Shopify.designMode === true ? 0 : 0.15`. Operator precedence
//     groups this as `(Shopify) || (Shopify.designMode === true) ? 0 : 0.15`,
//     and `Shopify` is always truthy on the storefront, so the ternary condition
//     was always true and `threshold` was always 0 — the 0.15 branch was dead
//     code. (An earlier fix here misread that as producing NaN and "corrected"
//     it to a literal 0.15. That broke collection pages: a fractional threshold
//     requires 15% of the SECTION's area to be visible, which is unreachable for
//     sections taller than ~6.7 viewports. The collection grid is 3755px against
//     an 805px viewport — max possible ratio 0.214, and far below 0.15 at load
//     while the section is still mostly below the fold. The grid stayed at
//     opacity:0 until a later scroll pushed it over. See commit d5accc8.)
//     0 is the correct value: reveal as soon as any pixel intersects.
//   - Immediate reveal in the theme editor (designMode) and for users who
//     prefer reduced motion.
//   - Resilience against late-arriving DOM, e.g. <product-recommendations>
//     swapping its innerHTML after the initial IntersectionObserver fire.
//   - A public window.Woolman.revealSection(el) escape hatch so third-party
//     widgets (Judge.me etc.) can force-reveal sections injected after load.
(function () {
  var isDesignMode =
    (typeof Shopify !== 'undefined') && Shopify && Shopify.designMode === true;

  var prefersReducedMotion = false;
  try {
    var mql = (typeof matchMedia === 'function')
      ? matchMedia('(prefers-reduced-motion: reduce)')
      : (typeof window !== 'undefined' && typeof window.matchMedia === 'function'
          ? window.matchMedia('(prefers-reduced-motion: reduce)')
          : null);
    prefersReducedMotion = !!(mql && mql.matches);
  } catch (e) {
    prefersReducedMotion = false;
  }

  var elements = document.querySelectorAll('.shopify-section');

  function revealSection(el) {
    if (!el || !el.classList) return;
    el.classList.add('section-anim-in');
    el.classList.add('section-in-view');
    try {
      el.dispatchEvent(new CustomEvent('section:in-viewport'));
    } catch (e) {
      // CustomEvent missing in very old environments; ignore.
    }
  }

  // Expose for late-loaded sections (e.g. Judge.me, app blocks).
  try {
    if (typeof window !== 'undefined') {
      window.Woolman = window.Woolman || {};
      window.Woolman.revealSection = revealSection;
    }
  } catch (e) {
    // no-op
  }

  // Short-circuit paths: in the theme editor or with reduced motion, reveal
  // everything immediately. No observer needed.
  if (isDesignMode || prefersReducedMotion) {
    elements.forEach(function (el) {
      revealSection(el);
    });
    return;
  }

  // Must stay 0 — see the operator-precedence note in the header. A fractional
  // threshold is unreachable for tall sections (collection grids) and traps them
  // at opacity:0 until the user scrolls.
  var threshold = 0;

  if (typeof IntersectionObserver !== 'function') {
    // No observer support: reveal everything so content is never trapped.
    elements.forEach(function (el) {
      revealSection(el);
    });
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('section-anim-in');
        entry.target.classList.add('section-in-view');
        try {
          entry.target.dispatchEvent(new CustomEvent('section:in-viewport'));
        } catch (e) {
          // ignore
        }
      } else {
        // Keep section-anim-in (once revealed, stays revealed). Only the
        // in-view marker comes and goes.
        entry.target.classList.remove('section-in-view');
      }
    });
  }, {
    root: null,
    rootMargin: '0px',
    threshold: [threshold, 1],
  });

  elements.forEach(function (el) {
    observer.observe(el);
  });

  // <product-recommendations> swaps its own innerHTML after a lazy fetch. The
  // host .shopify-section is normally revealed by the observer above, but if a
  // third party ever clones / re-mounts it we want to recover. Defence in depth.
  if (typeof MutationObserver === 'function') {
    var prHosts = document.querySelectorAll('product-recommendations');
    prHosts.forEach(function (pr) {
      var section = pr.closest ? pr.closest('.shopify-section') : null;
      if (!section) return;
      var mo = new MutationObserver(function () {
        // Only force-reveal if the section is already meant to be visible
        // (i.e. it is in the viewport / has been marked in-view).
        if (section.classList.contains('section-in-view') ||
            section.classList.contains('section-anim-in')) {
          section.classList.add('section-anim-in');
        }
      });
      mo.observe(pr, { childList: true, subtree: false });
    });
  }
})();
